import { faCalendarClock } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { alpha, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { formatDate } from "app/util/date/tools/common"
import { IFormInventory } from "form/inventory/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { getInventory } from "../tools/common"
import { FormInventoryMap } from "./FormInventoryMap"
import { FormInventoryMoney } from "./FormInventoryMoney"

interface IFormInventoryProps {
  inventory: IFormInventory | null
  contentWidth: number
}

const FormInventoryFn = React.memo(({ inventory, contentWidth }: IFormInventoryProps): JSX.Element | null => {
  if (!inventory) {
    return null
  }
  const { lastUpdate } = inventory
  const isForecast = inventory.isForecast
  return (
    <FlexBox
      id="campaign-form-inventory"
      vertical
      fullWidth
      ai="start"
      jc="start"
      sx={{
        p: "1rem",
        pt: ".5rem",
        pb: ".7rem",
        borderRadius: ".25rem",
        backgroundColor: theme => alpha(theme.palette.primary.main as string, 0.3)
      }}>
      <FlexBox jc="space-between" fullWidth wrap>
        <Typography
          sx={{
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: 500,
            mr: ".5rem",
            color: theme => theme.palette.text.primary2
          }}>
          {translate(isForecast ? "label.today.forecast.inventory" : "label.today.campaign.inventory")}
        </Typography>
        {contentWidth > 700 && (
          <FlexBox
            wrap
            sx={{
              "& .calendar-button": {
                color: theme => theme.palette.text.primary2
              }
            }}>
            <FontAwesomeIcon icon={faCalendarClock} className="calendar-button" />
            <Typography
              sx={{ fontSize: ".8rem", ml: ".5rem", fontWeight: 300, color: theme => theme.palette.text.primary2 }}>
              {formatDate(lastUpdate, { displayLong: true, displayTime: true })}
            </Typography>
          </FlexBox>
        )}
      </FlexBox>
      <FlexBox
        jc="space-between"
        sx={{
          width: "100%",
          maxWidth: "100%",
          mt: ".4rem",
          gap: "1rem"
        }}>
        <FormInventoryMoney inventory={inventory} contentWidth={contentWidth} />
        <FormInventoryMap inventory={inventory} />
      </FlexBox>
    </FlexBox>
  )
})

export const FormInventory = connect(
  (state: IRootState): IFormInventoryProps => ({
    inventory: state.app.activeContext ? getInventory(state) : null,
    contentWidth: state.ui.contentWidth
  })
)(FormInventoryFn)
